<div class="flex flex-row items-center">
  <div class="flex flex-row items-center justify-center">
    <mat-icon *ngIf="data.messages" class="icon-size-14" svgIcon="confirm_{{ data.type }}"></mat-icon>
    <mat-icon *ngIf="!data.messages" class="icon-size-12" svgIcon="confirm_{{ data.type }}"></mat-icon>
  </div>
  <div class="flex flex-col min-w-0">
    <span class="font-bold text-s2-16 text-theme-dark break-words">{{ data.title }}</span>
    <span class="whitespace-pre-line text-b2-14 text-theme-gray break-words">{{ data.messages }}</span>
  </div>
</div>
